import React, { Component } from 'react';

import { connect } from 'react-redux';
import { Box, Button, Loader } from '../../../common/components';
import InternalContainer from '../../layout/containers/Internal';
import { bindActionCreators } from 'redux';
import { actions } from '../redux/brokerApplicationActions';
import { actions as trackingLinkActions } from '../../trackingLinks/redux/trackingLinkActions';
import BrokerMessageDetails from '../components/BrokerMessageDetails/BrokerMessageDetails';

class BrokerMessageShowContainer extends Component {
  componentWillMount() {
    const {
      params: { id },
      actions,
    } = this.props;
    actions.getBrokerMessage(id);
  }

  handleTab(key) {
    this.setState({ activeTab: key });
  }

  createTrackingLinkFromMessage = (values) => {
    const { trackingLinkActions } = this.props;

    trackingLinkActions.createTrackingLinkBroker(values);
  };

  render() {
    const { brokerMessage } = this.props;
    const buttons = (
      <Button bsStyle="default" label="Back" isBackButton={true} leftIcon="caret-left" />
    );
    return (
      <InternalContainer title={'Admin Fees'} buttons={buttons}>
        {brokerMessage ? (
          <Box>
            <BrokerMessageDetails
              brokerMessage={brokerMessage}
              createTrackingLinkFromMessage={this.createTrackingLinkFromMessage}
            />
          </Box>
        ) : (
          <Loader />
        )}
      </InternalContainer>
    );
  }
}

export default connect(
  (state) => {
    return {
      brokerMessage: state.brokerApplication.brokerMessage,
    };
  },
  (dispatch) => ({
    actions: bindActionCreators(actions, dispatch),
    trackingLinkActions: bindActionCreators(trackingLinkActions, dispatch),
  }),
)(BrokerMessageShowContainer);
